import css from 'styled-jsx/css'
import { colors } from '../../styles'

export default css`
.SocialShares {
  background-color: ${colors.elevatedBg};
  color: ${colors.primaryText};
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  z-index: 2;
}

ul {
  display: flex;
  padding: 0;
  list-style: none;
  margin: 0;
}

h2 {
  font-size: 18px;
  text-transform: uppercase;
  font-weight: normal;
}

@media (min-width: 1024px) {
  .SocialShares {
    position: fixed;
    bottom: 0;
    right: 0;
    padding-left: 50px;
    padding-right: 50px;
  }
}
`

export const itemStyle = css`
li {
  margin: 0 8px;
}

li a {
  color: ${colors.primaryText};
  display: flex;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  transition: 100ms background-color;
}

a:hover, a:focus {
  color: ${colors.white};
}

.twitter:hover, .twitter:focus {
  background-color: ${colors.twitter};
}
.facebook:hover, .facebook:focus {
  background-color: ${colors.facebook};
}
.email:hover, .email:focus {
  background-color: ${colors.email};
}
`
